import { createSlice } from '@reduxjs/toolkit';
import { login } from 'pages/LoginPage/thunk';

type InitialState = {
  isAuth: boolean;
};

const initialState: InitialState = {
  isAuth: false,
};

const AppSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    loginWithToken: (state) => {
      return { ...state, isAuth: true };
    },
    logOut: (state) => {
      return { ...state, isAuth: false };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, action) => ({ ...state, isAuth: true }));
  },
});

export const { loginWithToken, logOut } = AppSlice.actions;

export default AppSlice.reducer;
